"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.createSitemapEntry = void 0;
var _utils = require("../utils");
var _entityLite = require("./entity-lite");
var _seoLite = _interopRequireDefault(require("./seo-lite"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var createSitemapEntry = function createSitemapEntry(_ref) {
  var _sys$contentType;
  var sys = _ref.sys,
    fields = _ref.fields;
  var entity = (0, _entityLite.createEntityLite)({
    sys: sys,
    fields: fields
  });
  var contentType = (0, _utils.getProp)(sys === null || sys === void 0 ? void 0 : (_sys$contentType = sys.contentType) === null || _sys$contentType === void 0 ? void 0 : _sys$contentType.sys, 'id');
  var seo = contentType === 'page_v2' ? {
    fields: fields
  } : (0, _utils.getProp)(fields, 'seo');
  if (!seo) return null;
  var seoLite = (0, _seoLite["default"])(seo);
  if (seoLite.noIndex !== false) return null;
  var pageType = (0, _utils.getProp)(fields, 'pageType');
  var url = pageType === 'home' ? '/' : entity.url;
  return {
    url: url,
    lastModified: entity.lastUpdated,
    changeFrequency: seoLite.changeFrequency,
    priority: seoLite.priority
  };
};
exports.createSitemapEntry = createSitemapEntry;
var sitemapEntryFactory = function sitemapEntryFactory(items) {
  return items.map(createSitemapEntry).filter(function (entity) {
    return entity;
  });
};
var _default = sitemapEntryFactory;
exports["default"] = _default;